import { UserEvent } from '@/types/UserEvent';
import { groupActivityByDate } from '@/utils/group-activity';
import { ActivityPoint } from './HeatMap';
import { getCurrentStreak } from '@/utils/get-current-streak';
import ActivityCard from './ActivityCard';

interface GuestActivityHeatmapProps {
  userEvents: UserEvent[];
}

const GuestActivityHeatmap = (props: GuestActivityHeatmapProps) => {
  const { userEvents } = props;

  const grouped = groupActivityByDate(userEvents);
  const countPerDay: ActivityPoint[] = Object.keys(grouped).map((key) => ({
    date: key,
    value: grouped[key].length,
  }));

  if (!userEvents.length) {
    return <div>You have no used the review sessions yet.</div>;
  }

  // const streak = 0;
  const streak = getCurrentStreak(countPerDay);

  return (
    <ActivityCard
      eventCount={userEvents.length}
      activity={countPerDay}
      currentStreak={streak}
    />
  );
};

export default GuestActivityHeatmap;
